import { Component, Input } from '@angular/core';
import { obterDescricaoPeriodoAquisitivo } from '../models/periodo-aquisitivo';
import { ExercicioSelecionado } from 'src/app/services/exercicios.service';

@Component({
    selector: 'app-cabecalho-funcional',
    templateUrl: './cabecalho-funcional.component.html',
    styleUrls: ['./cabecalho-funcional.component.scss']
})
export class CabecalhoFuncionalComponent {
    @Input({ required: true }) exercicioSelecionado!: ExercicioSelecionado;
    @Input() quantidadeDias?: number | null;
    @Input() periodoAquisitivo?: string | null;
    @Input() exibirPeriodoProgramacaoDisponivel = false;
    @Input() exibirTipoPeriodoAquisitivo = false;

    get quantidadeDiasExibida(): number | null {
        return this.quantidadeDias === undefined ? this.exercicioSelecionado.saldoDias : this.quantidadeDias;
    }

    get descricaoTipoPeriodoAquisitivo(): string {
        const periodoAquisitivo = this.periodoAquisitivo === undefined ? this.exercicioSelecionado.periodoAquisitivo : this.periodoAquisitivo;
        return obterDescricaoPeriodoAquisitivo(periodoAquisitivo);
    }

    onTooltipTouchStart(event) {
        event.preventDefault();
        const mouseenterEvent = new Event('mouseenter', { cancelable: false });
        event.target.dispatchEvent(mouseenterEvent);
    }

    onTooltipTouchEnd(event) {
        event.preventDefault();
        const mouseleaveEvent = new Event('mouseleave', { cancelable: false });
        event.target.dispatchEvent(mouseleaveEvent);
    }
}
